// removed by extract-text-webpack-plugin
module.exports = {"m10":"OSeO","mb5":"_3aeY","mb15":"_1TXB","mb30":"I0nU","mb20":"_26A3","mt30":"_2djQ","mt60":"HNrU","mt15":"_1aeU","mb60to30":"_2XeN","mt60to30":"NPa_","mb60to15":"iO2s","mb30to15":"NBHQ","mv60to30":"_3Ldi","mv30to15":"_3sdK","mv30":"JcBW","mv15":"_3b7H","p30":"_1cQ4","pv60to30":"fPS6","pv30to15":"Zomv","pl10to0":"_38d4","ml15":"SVOg","mr15":"hZoE","mb15xs":"_1dFT","w100":"Z6Cp","w100xs":"_1VlI"};


//////////////////
// WEBPACK FOOTER
// ./~/@pickle/pickle-shared/src/styles/modules/margins.scss
// module id = lu7e
// module chunks = 0